import { FieldError, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Label from '../../../components/atoms/display/Label'
import { FlexColumn, FlexRow } from '../../../components/atoms/layout/Flex'
import Button from '../../../components/atoms/inputs/Button'
import DotPagination from '../../../components/atoms/navigation/DotPagination'
import useYup from '../../../hooks/useYup'
import useValidationRule from '../../../hooks/useValidationRule'
import useRouter from '../../../hooks/useRouter'
import Form from '../../../components/atoms/inputs/Form'
import FullNameField from '../../../components/molecules/inputs/FullNameField'
import Checkbox from '../../../components/atoms/inputs/Checkbox'
import { SessionSelectors } from '../../../store/session/selectors'
import { SessionActions } from '../../../store/session'
import { CompanyActions } from '../../../store/company'

type UserNameParams = {
  name?: string
}

export default function RegisterContracteeUserName() {
  const user = useSelector(SessionSelectors.user)
  const yup = useYup()
  const rules = useValidationRule()
  const schema = yup.object().shape({
    name: rules.userName.required(),
  })
  const form = useForm<UserNameParams>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      name: user?.name,
    },
  })
  const router = useRouter()
  const [isRepresentative, setIsRepresentative] = useState(false)
  const [useAgreementFeature, setUseAgreementFeature] = useState(false)
  const dispatch = useDispatch()

  const handleNext = useCallback(
    (params: UserNameParams) => {
      if (user && params.name) {
        dispatch(
          SessionActions.updateMe({
            user: { ...user, name: params.name },
          })
        )
      }
      if (isRepresentative && useAgreementFeature) {
        if (user) {
          dispatch(CompanyActions.saveRepresentative({ userId: user.id, message: false }))
        }
        router.registerContracteeRepresentative()
      } else {
        router.registerContracteeBank()
      }
    },
    [dispatch, isRepresentative, useAgreementFeature, router, user]
  )

  return (
    <Form onSubmit={form.handleSubmit(handleNext)}>
      <FlexColumn align="center" height="calc(100vh - 128px)" justify="space-between" mt={4}>
        <FlexColumn align="center">
          <Label text="ユーザー名の設定" variant="title" />
          <FlexColumn width="360px">
            <Label text="ユーザー名を入力してください" />
            <FlexColumn width="360px">
              <FullNameField
                register={form.register('name')}
                size="md"
                error={form.formState.errors.name as FieldError}
              />
            </FlexColumn>
            <Checkbox label="代表者としてmonectに登録する" checked={isRepresentative} onChange={setIsRepresentative} />
            <Checkbox
              label="monectで契約機能を利用する"
              checked={useAgreementFeature}
              onChange={setUseAgreementFeature}
            />
          </FlexColumn>
        </FlexColumn>
        <FlexColumn align="center">
          <Button type="submit" size="lg">
            次へ
          </Button>
          <FlexRow justify="center">
            <DotPagination count={13} current={9} />
          </FlexRow>
        </FlexColumn>
      </FlexColumn>
    </Form>
  )
}
